import React, { useState,useContext } from "react";
import { MDBInput } from "mdb-react-ui-kit";

import Select from "react-select";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import {
  DELETE_USER,
  VIEW_USER,
  ROLE_LIST,
  EDIT_USER,
  INSERT_USER,
  UPDATE_USER,
  BASE_URL_CHAT_WHATSAPP,
} from "../../../constants";

import NotificationAlert from "react-notification-alert";

import Papa from "papaparse";
import * as XLSX from "xlsx";

import { useHistory } from "react-router-dom";
import userContext from "../../../context/UserContext";
const CreateImageModel = () => {
  var filepath =""
  let drpdwn = [];
  const notificationAlertRef = React.useRef(null);
  const navigate = useHistory();

  const initialData = {
    name: "",
    file: "",
    targetFile: "",
    optimizer: "",
    activtaionfn: "",
    lossunit: "",
  };

  const [textdata, setTextData] = useState(initialData);

  const [trgtDrpDwn, setTrgtDrpDwn] = useState([]);

  const onchangeHandler = (e) => {
    const { name, value } = e.target;
    setTextData({ ...textdata, [name]: value });
  };

  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });
const data = useContext(useContext);
console.log('====================================')
console.log(data)
console.log('====================================')
  const chooseFile = (e) => {
    let a = e.target.value.split(".");
    const files = e.target.files[0];
    filepath = files.name;
    const reader = new FileReader();
    reader.readAsDataURL(files);

    reader.onload = () => {
      setTextData({ ...textdata, file:reader.result  });
    };
    if (a[1] == "csv") {
      if (files) {
        Papa.parse(files, {
          complete: (result) => {
            result?.meta?.fields?.map((item, index) => {
              drpdwn.push({
                value: item,
                label: item,
              });
            });
          },
          header: true,
        });
      }
    } else if (a[1] == "xlsx") {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonSheet = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonSheet.length > 0) {
          jsonSheet[0]?.map((item, index) => {
            drpdwn.push({
              value: item,
              label: item,
            });
          });
        }
      };

      reader.readAsArrayBuffer(files);
    }
    setTrgtDrpDwn(drpdwn);
    setTextData({ ...textdata, targetFile: "" });
  };

  const submitInsertUser = () => {
    console.log("---->161--", textdata);
    // if(updateUserId){
    //  let resultuser={
    //     id:updateUserId.toString(),
    //     username: users.username,
    //     password: users.password,
    //     mobile: users.mobile,
    //     email: users.email,
    //     role: singleSelect.value,
    //     tuserstatus: `${isActive?"inactive":"active"}`,
    //     usertype: singletypeSelect.value,
    //     channel: singleChnlSelect.value,
    //     agenttype: levelSelect.value,
    //     senderId:users.senderId
    //   }
    //   setValidate({
    //     message:"",
    //     notValid:false
    //   })

    // axios
    //   .post(UPDATE_USER, resultuser)
    //   .then((response) => {
    //     setModalClassic(false);
    //     let options = {};
    //     options = {
    //       place: "tr",
    //       message: "Updated Successfully",
    //       type: "success",

    //       autoDismiss: 2,
    //     };
    //     notificationAlertRef.current.notificationAlert(options);
    //     setUsers(initialState);
    //     setsingleSelect(null);
    //     setsingleTypeSelect(null);
    //     setsingleChnlSelect(null);
    //     setLevelSelect(null);
    //     viewUserList(currentPage);
    //     setUpdateUserId(0)
    //   })
    //   .catch((error) => {
    //     console.log("catch--", error);
    //   });
    // }else{

    //   if(isvalidUser()){
    //     let resultuser = {
    //       username: users.username,
    //       password: users.password,
    //       mobile: users.mobile,
    //       email: users.email,
    //       role: singleSelect.value,
    //       tuserstatus: `${isActive?"inactive":"active"}`,
    //       usertype: singletypeSelect.value,
    //       channel:singleChnlSelect.value,
    //       agenttype:levelSelect.value,
    //       senderId:users.senderId
    //     };
    //     setValidate({
    //       message:"",
    //       notValid:false
    //     })
    //     axios
    //     .post(INSERT_USER, resultuser)
    //     .then((response) => {
    //       setModalClassic(false);
    //       let options = {};
    //       options = {
    //         place: "tr",
    //         message: "Saved Successfully",
    //         type: "success",

    //         autoDismiss: 2,
    //       };
    //       notificationAlertRef.current.notificationAlert(options);
    //       setUsers(initialState);
    //       setsingleSelect(null);
    //       setsingleTypeSelect(null);
    //       setLevelSelect(null);
    //       setsingleChnlSelect(null);
    //       viewUserList(currentPage);
    //       setUpdateUserId(0)
    //     })
    //     .catch((error) => {
    //       console.log("catch--", error);
    //     });
    //   }

    // }
  };

  // const isvalidUser=()=>{
  //   if(users.username ==""){
  //     setValidate({
  //       message:"Please enter username",
  //       notValid:true
  //     })

  //     return false
  //   }else if(users.password.length<8){
  //     setValidate({
  //       message:"Password length shoud be greater than 8 charcters",
  //       notValid:true
  //     })

  //     return false;
  //   }else if(users.mobile.length != 12){
  //     setValidate({
  //       message:"Mobile Number  shoud be 12 digits",
  //       notValid:true
  //     })

  //     return false;
  //   }else if(users.email.length<5){
  //     setValidate({
  //       message:"Please Enter Email",
  //       notValid:true
  //     })

  //     return false;
  //   }else if(!users?.email.includes("@")){
  //     setValidate({
  //       message:"Please Enter Valid Email",
  //       notValid:true
  //     })

  //     return false;
  //   }else if(!users?.email.includes(".com")){
  //     setValidate({
  //       message:"Please Enter Valid Email",
  //       notValid:true
  //     })

  //     return false;
  //   }

  //   else if(singleSelect?.value== undefined){
  //     setValidate({
  //       message:"Please Select Role",
  //       notValid:true
  //     })

  //     return false;
  //   }else if(singletypeSelect?.value== undefined){

  //     setValidate({
  //       message:"Please Select User Type",
  //       notValid:true
  //     })

  //     return false;

  //   }
  //   else{
  //     setValidate({
  //       message:"",
  //       notValid:false
  //     })

  //     return true;
  //   }

  //  // users.username&&users.password&&users.mobile&&users.email

  // }

  return (
    <>
      <div className="content pd-0">
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Col sm="12">
                <Row>
                  <Col sm="9">
                    <h4 className="mt-4">
                      <Button
                        className="btn btn-icon btn-round btn-success"
                        onClick={() =>
                          navigate.push("/admin/ai/image/imagemodels")
                        }
                      >
                        <i class="tim-icons icon-minimal-left"></i>
                      </Button>
                      Create Model
                    </h4>
                  </Col>
                </Row>
              </Col>

              <Row>
                {validate.notValid && (
                  <span style={{ color: "red" }}>{validate.message}</span>
                )}
                <Col sm="4" className="mb-2">
                  <MDBInput
                    label="Name"
                    type="text"
                    name="name"
                    value={textdata.name}
                    onChange={(e) => onchangeHandler(e)}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <input
                    type="file"
                    id="file"
                    accept=".csv,.xlsx"
                    onChange={(e) => chooseFile(e)}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="targetfile"
                    value={textdata.targetFile}
                    onChange={(value) => {
                      setTextData({ ...textdata, targetFile: value });
                    }}
                    options={trgtDrpDwn}
                    placeholder="Select Target File"
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="optimizer"
                    value={textdata.optimizer}
                    onChange={(value) =>
                      setTextData({ ...textdata, optimizer: value })
                    }
                    options={drpdwn}
                    placeholder="Select Optimizer"
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="activationfn"
                    value={textdata.activtaionfn}
                    onChange={(value) =>
                      setTextData({ ...textdata, activtaionfn: value })
                    }
                    options={drpdwn}
                    placeholder="Select Activation Fn"
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="lossunit"
                    value={textdata.lossunit}
                    onChange={(value) =>
                      setTextData({ ...textdata, lossunit: value })
                    }
                    options={drpdwn}
                    placeholder="Select Loss Unit"
                  />
                </Col>

                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={() => submitInsertUser()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreateImageModel;
